import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, InputAdornment } from '@mui/material';
import SelectField from 'components/select-field';
import TextField from 'components/text-field';
import { ListingEntry } from 'graphql/listings/queries';
import { Status } from 'hooks/useGetOrderStatuses';
import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DatesAndConfigurationForm } from '../services';
import Title from './title';

type FormConfigProps = {
  workflows: ListingEntry[],
  settelmentStatements: ListingEntry[],
};

const getStatusList = (t: TFunction): Status[] => [
  {
    name: "open",
    text: t('orders:open')
  },
  {
    name: "hold",
    text: t("orders:hold")
  },
  {
    name: "closed",
    text: t("orders:closed")
  },
  {
    name: "canceled",
    text: t("orders:cancelled")
  }
];

const FormConfig = ({
  workflows,
  settelmentStatements
}: FormConfigProps) => {
  const { control, getValues } = useFormContext<DatesAndConfigurationForm>();

  const { t } = useTranslation();

  const statusList = useMemo(() => getStatusList(t), [t]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title>{t('datesAndConfig:configuration')}</Title>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          disabled
          label={`${t('orders:order')} #`}
          value={getValues('order_id')}
          InputProps={{
            sx: { '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: 'currentColor' } },
            endAdornment: (
              <InputAdornment position="end" sx={{ color: 'inherit' }}>
                <FontAwesomeIcon icon="edit" size="xs" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <SelectField
              inputRef={field.ref}
              value={field.value}
              label={t('orders:settlement-statement')}
              data={settelmentStatements}
              dataKey="code"
              dataValue="code"
              dataText="description"
              handleBlur={field.onBlur}
              handleChange={(e) => {
                field.onChange(e);
              }}
            />
          )}
        />

      </Grid>
      {!!workflows.length && (
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name="workflow"
            render={({ field }) => (
              <SelectField
                value={field.value}
                inputRef={field.ref}
                label={t('datesAndConfig:workflow')}
                data={workflows}
                dataKey="code"
                dataValue="code"
                dataText="description"
                handleBlur={field.onBlur}
                handleChange={(event) => field.onChange(event.target.value)}
              />
            )}
          />

        </Grid>
      )}

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="status"
          render={({ field }) => (
            <SelectField
              value={field.value}
              inputRef={field.ref}
              label={t('datesAndConfig:status')}
              data={statusList}
              dataKey="name"
              dataValue="name"
              dataText="text"
              handleBlur={field.onBlur}
              handleChange={(event) => field.onChange(event.target.value)}
              helperText={t('datesAndConfig:statusHelperText')}
            />
          )}
        />

      </Grid>
    </Grid>
  );
};

export default FormConfig;
